import { all } from 'redux-saga/effects';
import getDataFromServer  from './server.middleware';
import beforeMiddleWare from './all.before.middleware';

export default function* middlewares() {
    yield all([
        beforeMiddleWare(),
        getDataFromServer()
    ])
}